let last_time = Date.now();


export default {
	
	/**
	 * Does this device support touch input?
	 * @return {boolean}
	 */
	isTouch() {
		return (
			('ontouchstart' in window)
			|| (navigator.maxTouchPoints > 0)
		);
	},

	get_query( key ) {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get(key);
	},
	
	
	/**
	 * Get time elapsed since last timestamp
	 * @return {int}
	 */
	elapsed() {
		const current_time = Date.now();
		const elapsed = current_time - last_time;
		last_time = current_time;
		return elapsed;
	},
	
	
	/**
	 * Log with elapsed time
	 * @param {mixed} arguments
	 */
	log() {
		let time = this.elapsed();
		Array.from(arguments).forEach(data => {
			time = time.toString().padStart(5, ' ');
			if (typeof data !== 'object') {
				console.log(`${time}: ${data}`);
			} else {
				console.log(`${time}:`, data);
			}
			time = '';
		});
	},
	
	
	/**
	 * Is this valid JSON?
	 * @param {string} text
	 * @return {boolean}
	 */
	isValidJSON(text) {
		try {
			JSON.parse(text);
			return true;
		} catch {
			return false;
		}
	},
	
	
	/**
	 * Is this CSS selector valid?
	 * @param {string} selector
	 * @return {boolean}
	 */
	isValidSelector(selector) {
		try {
			document.createDocumentFragment().querySelector(selector);
			return true;
		} catch {
			return false;
		}
	},
	
	
	/**
	 * Get current URL
	 * @return {string}
	 */
	currentURL() {
		return window.location.protocol
			+ '//'
			+ window.location.hostname
			+ (window.location.port ? ':' + window.location.port : '')
			+ window.location.pathname
		;
	},
	
	
	/**
	 * Generate random ID
	 * @param {int} digits
	 * @param {boolean} as_string
	 * @return {int|string}
	 */
	randomID(digits = 5, as_string = true) {
		const min = (!as_string)
			? Math.pow(10, digits - 1)
			: 0;
		const max = Math.pow(10, digits) - 1;
		const id = Math.floor(Math.random() * (max - min + 1)) + min;
		return (as_string)
			? id.toString().padStart(digits, '0')
			: id;
	},
	
	
	kebab(string) {
		return this.mechanize(string, '-');
	},
	chain(string) {
		return this.mechanize(string, '-');
	},
	snake(string) {
		return this.mechanize(string, '_');
	},
	compact(string) {
		return this.mechanize(string, '');
	},
	
	
	/**
	 * Mechanize
	 * @param {string} string
	 * @param {string} separator
	 * @return {string}
	 */
	mechanize(string, separator = '_') {
		if (!string.length) return '';
		
		string = string.toLowerCase();
		string = this.transliterate(string);
		string = string
			.replace(/['’]/g, '')
			.replace(/[^a-z0-9\s_]/g, '_')
			.replace(/[\s_]+/g, '_')
			.replace(/^_|_$/g, '')
		;
		if (separator !== '_') {
			string = string.replace(/_/g, separator);
		}
		return string;
	},
	
	
	/**
	 * Transliterate
	 * @param {string} string
	 * @return {string}
	 */
	transliterate(string) {
		const transliterations = {
			a: 'аáăâäàāąåãǻǎ',
			ya: 'я',
			ae: 'æǽ',
			b: 'б',
			c: 'ћćčçĉċ',
			ch: 'ч',
			d: 'дðďđ',
			dzh: 'џ',
			dz: 'ѕ',
			dj: 'ђ',
			e: 'еэéĕěêëėèēę',
			ye: 'є',
			f: 'ф',
			g: 'гґğĝģġ',
			h: 'ħĥ',
			i: 'иіıíĭîïìīįĩǐ',
			yi: 'ї',
			ij: 'ĳ',
			j: 'йȷĵ',
			k: 'кķ',
			kh: 'х',
			l: 'лĺľļŀł',
			lj: 'љ',
			m: 'м',
			n: 'нńňņñ',
			nj: 'њ',
			ng: 'ŋ',
			o: 'оóŏôöòőōøõǿǒơ',
			yo: 'ё',
			oe: 'œ',
			p: 'п',
			r: 'рŕřŗ',
			s: 'сśšşŝș',
			ss: 'ß',
			sh: 'ш',
			shch: 'щ',
			t: 'тŧťţț',
			ts: 'ц',
			th: 'þ',
			u: 'уúŭûüùűūųůũǔǖǘǚǜư',
			yu: 'ю',
			v: 'в',
			w: 'ўẃŵẅẁ',
			y: 'ыýŷÿỳ',
			z: 'зźžż',
			zh: 'ж',
			
			A: 'АÁĂÂÄÀĀĄÅÃǺǍ',
			Ya: 'Я',
			Ae: 'ÆǼ',
			B: 'Б',
			C: 'ЋĆČÇĈĊ',
			Ch: 'Ч',
			D: 'ДÐĎĐ',
			Dzh: 'Џ',
			Dz: 'Ѕ',
			Dj: 'Ђ',
			E: 'ЕЭÉĔĚÊËĖÈĒĘ',
			Ye: 'Є',
			F: 'Ф',
			G: 'ГҐĞĜĢĠ',
			H: 'ĦĤ',
			I: 'ИІIÍĬÎÏİÌĪĮĨǏ',
			Yi: 'Ї',
			Ij: 'Ĳ',
			J: 'ЙĴ',
			K: 'КĶ',
			Kh: 'Х',
			L: 'ЛĹĽĻĿŁ',
			Lj: 'Љ',
			M: 'М',
			N: 'НŃŇŅÑ',
			Nj: 'Њ',
			Ng: 'Ŋ',
			O: 'ОÓŎÔÖÒŐŌØÕǾǑƠ',
			Yo: 'Ё',
			Oe: 'Œ',
			P: 'П',
			R: 'РŔŘŖ',
			S: 'СŚŠŞŜȘ',
			// SS: 'SS',
			Sh: 'Ш',
			Shch: 'Щ',
			T: 'ТŦŤŢȚ',
			Ts: 'Ц',
			Th: 'Þ',
			U: 'УÚŬÛÜÙŰŪŲŮŨǓǕǗǙǛƯ',
			Yu: 'Ю',
			V: 'В',
			W: 'ЎẂŴẄẀ',
			Y: 'ЫÝŶŸỲ',
			Z: 'ЗŹŽŻ',
			Zh: 'Ж',
			
			1: '¹',
			2: '²',
			3: '³',
			4: '⁴',
		};
		
		for (let key in transliterations) {
			const regex = new RegExp('[' + transliterations[key] + ']', 'g');
			string = string.replace(regex, key);
		}
		return string;
	},
	
};
